export default "__VITE_ASSET__Bvn24IjQ__"